import React, { useEffect } from 'react';
import { KodanshaNavbar } from './KodanshaNavbar/KodanshaNavbar';
import { useAtom } from 'jotai';
import { HomeAtom } from '../store/HomeStore';
import { KodanshaFooter } from './KodanshaFooter/KodanshaFooter';
import { KodanshaWheel } from './KodanshaWheel/KodanshaWheel';
import KodanshaSubscription from './KodanshaSubscription/KodanshaSubscription';
import { KodanshaNewsWheel } from './KodanshaNewsWheel/KodanshaNewsWheel';
import KodanshaOffers from './KodanshaOffers/KodanshaOffers';
import KodanshaHeader from './KodanshaHeader/KodanshaHeader';
import './KodanshaHome.scss';
import { CheckoutOverlayVisible } from '../store/OverlayStore';
import KodanshaArrow from './KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import KodanshaResume from './KodanshaUIKit/KodanshaResume/KodanshaResume';
import { AccountInfoAtom, LoginStatus, LoginStatusAtom } from '../store/AccountStore';
import NewBenefits from './Benefits/NewBenefit';
import GenreBrowse from './GenreBrowse/GenreBrowse';
import { FetchReadingProgressAtom } from '../store/ReadingProgressStore';
import { Link } from '../Devon/Components/InkyLink';
import { KodanshaCustomWheelSection } from './CustomWheelSection/KodanshaCustomWheelSection';
import { HomeModel } from '../Models/HomeModel';
import { Helmet } from 'react-helmet';
import KodanshaChaptersWheel from './KodanshaWheel/KodanshaChaptersWheel';
import { readerReadableUrlOrDefault } from '../utils/utils';


// console.log("")


// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
export const SpawnSections = (): JSX.Element => {
    const [home, setHome] = useAtom(HomeAtom);

    useEffect(() => {
        console.log('home init', home);
        setHome();
    }, []);

    return <>
        {(home as HomeModel)?.entries.length > 0 ? (home as HomeModel)?.entries?.map((section) => {
            if (!section.id) {
                return null;
            }
            return <KodanshaWheel key={section.id} title={section.title} discoverId={section.id} buttonUrl={section.customCallToActionUrl} ctaText={section.customCallToActionText} useCTA={(!!section.customCallToActionUrl||!!section.customCallToActionText)} />;
        }) : null}
    </>;

    // const sectionsArray = [];
    // sectionsArray.push(<KodanshaWheel key={section.id} title={section.title} discoverId={section.id} />);
    // return sectionsArray;
};


export function KodanshaHome(props: { showCheckout?: boolean }): JSX.Element {
    const [_, setCheckoutOverlay] = useAtom(CheckoutOverlayVisible);
    const [readingProgress, fetchReadingProgress] = useAtom(FetchReadingProgressAtom);
    const [loginStatus] = useAtom(LoginStatusAtom);
    const [AccountInfo] = useAtom(AccountInfoAtom);

    useEffect(() => {
        if (AccountInfo.email) {
            const fetch = fetchReadingProgress();
        }
    }, [AccountInfo]);

    useEffect(() => {
        if (props.showCheckout) {
            setCheckoutOverlay(true);
        }
    }, []);


    return (<main className='home-outer-container'>
        <Helmet>
            <title>Manga & Books - Discover Kodansha</title>
            <meta name='description'
                  content='For over a century, Kodansha has relentlessly pursued quality and creativity, which allows us to continuously reimagine what could be. We see the world without restrictions. A place of diverse passions, profound perspectives and limitless potential. Filled with curious minds and unexpected voices. And as we continue to shine a light on them, there is no telling how much further we can go.' />
        </Helmet>
        <KodanshaNavbar />
        <KodanshaHeader />

        <div className={'home-inner-container'}>
            <div className='max-wrapper'>
                {/*<ExpoGoodies />*/}

                {readingProgress?.length > 0 && loginStatus === 'LoggedIn' && <><h3
                    className='continue-reading-title'>Continue Reading</h3>
                    <div className='resume-book-outer-wrapper-2'>
                        {readingProgress.map((item, index) => index <= 1 ?
                            <div key={item.comicId} className='resume-book-wrapper'>
                                <KodanshaResume readingProgress={item.readingProgress} chapterName={item.comicName}
                                                chapterNumber={item.chapterNumber} volumeNumber={item.volumeNumber}
                                                productType={item.productType}
                                                seriesId={item.seriesId}
                                                readableUrl={item.readableUrl}
                                                readerLink={readerReadableUrlOrDefault(item)}
                                                seriesReadableUrl={item.seriesReadableUrl}
                                                src={item.thumbnailURL} id={item.comicId} />
                                {/*<div className='resume-divider' />*/}
                            </div> : null)}
                    </ div>
                </>}

                <KodanshaOffers />
            </div>

            {/*<div className='max-wrapper'>*/}
            {/*    <KodanshaLatestChapters showLatestPoster={true} />*/}
            {/*    <KodanshaArrow text={'View all updates'} withArrow />*/}
            {/*</div>*/}

            <div className='max-wrapper-mobile'>
                {/*{loginStatus !== "LoggedIn" && <Benefits />}*/}
                {loginStatus !== 'LoggedIn' && <NewBenefits />}
                {/*<ExpoGoodies />*/}
            </div>

            <KodanshaChaptersWheel />

            <KodanshaCustomWheelSection />
            {/*{SpawnSections()}*/}
            <SpawnSections />

            <div className='max-wrapper-mobile'>
                <GenreBrowse
                    title={'Browse by Genre'}
                    genres={[
                        {id:12, title:'Action & Adventure'},
                        {id:9, title:'Comedy'},
                        {id:2, title:'Romance'},
                        {id:4, title:'Fantasy'},
                        {id:1, title:'Drama'},
                        {id:6, title:'Horror'},
                    ]}
                />
            </div>

            <div className='max-wrapper' style={{ marginTop: '30px' }}>

                <KodanshaNewsWheel title={'Recent news'} />
                <Link to={'/news'} className='go-tp-news'
                      onClick={e => e.stopPropagation()}>
                    <KodanshaArrow text={'View more'} withArrow />
                </Link>
                {/*<span className='explore-text'>EXPLORE</span>*/}
                {/*<KodanshaPopulars withBrowseMange={true} />*/}
            </div>
        </div>

        <KodanshaSubscription />
        <KodanshaFooter />
    </main>);
}

// Don't remove the code commented out :)

{/*<KodanshaFeaturedRelease />*/
}

{/*<KodanshaHeroBanner />*/
}
{/*{<KodanshaWheel title={'Latest from Days'} key={'CoolSeries'} sid={"1724"} />}*/
}
{/*{<KodanshaWheel title={'Waiting for Spring'} key={'CoolSeries'} sid={"1791"} />}*/
}
{/*<KodanshaNewsWheel title={"Free for a limited time"}/>

            <KodanshaCarouselExtended title={"Latest Chapters"} />


            <KodanshaCarousel title={"Popular Series"}/>
            <KodanshaCarousel title={"Read Brand New Series"}/>

            <KodanshaNewsWheel title={"Recent news"}/>*/
}


{/*{loginStatus !== "LoggedIn" && width > 768 &&*/
}
{/*    <div className='max-wrapper'>*/
}
{/*        <SignupHomePage />*/
}
{/*    </div>}*/
}

{/*<KodanshaPopularSlider type={'series'} title={'#Popular Series'} />*/
}
{/*<KodanshaPopularSlider type={'series'} title={'#Read Brand New Series'} />*/
}

{/*{loginStatus !== "LoggedIn" && width <= 768 && <SignupHomePage />}*/
}

{/*<KodanshaPopularSlider type={'product'} title={'#Latest Releases'} />*/
}
{/*<KodanshaPopularSlider type={'product'} title={'#On Sale'} />*/
}

// const {
//     data,
//     loading,
//     fetch,
//     error,
// } = useLazyFetch<Product>(() =>
//     apiClient.getProductById(6095, null, 600), false);
// const product: Product = data as Product;
// <ReaderEndCard currentProduct={product} nextProduct={product} isOwnedByUser={false} />

